import type { FolderTreeNode } from './folderTree'

/** 选中路径各级祖先（不含根空串），用于自动展开树 */
export function folderPathAncestorSet(path: string): Set<string> {
  const s = new Set<string>()
  if (!path) return s
  const parts = path.split('/').filter(Boolean)
  let acc = ''
  for (let i = 0; i < parts.length; i++) {
    acc = i === 0 ? parts[0] : `${acc}/${parts[i]}`
    s.add(acc)
  }
  return s
}

/** 首次展开：所有顶层节点 + 选中路径链 */
export function folderTreeInitialExpandedKeys(roots: FolderTreeNode[], selectedPath: string): Set<string> {
  const next = new Set<string>()
  for (const r of roots) next.add(r.path)
  for (const p of folderPathAncestorSet(selectedPath)) next.add(p)
  return next
}

/** 随选中或数据变化合并展开状态（保留用户已手动展开） */
export function folderTreeMergeExpandedKeys(
  prev: Set<string>,
  roots: FolderTreeNode[],
  selectedPath: string,
): Set<string> {
  const merged = new Set(prev)
  for (const p of folderPathAncestorSet(selectedPath)) merged.add(p)
  for (const r of roots) merged.add(r.path)
  return merged
}
